import { BusinessAreasWithServices, Service } from 'types/Service';

export interface ServicesState {
    services: Array<Service>;
    businessAreas: Array<BusinessAreasWithServices>;
    status: ServiceStatus;
    loading: boolean;
}

export enum ServiceStatus {
    Initial,

    Fetching,
    FetchSuccess,

    Error
}
